import { 
    gql, 
    useQuery 
} from "@apollo/client";
import { 
    QuerySearchMerchantArgs,
    SearchMerchantQueryQuery 
} from "../../../schemaTypes";
import { useCallback } from "react";

export const searchMerchantQuery = gql`
  query SearchMerchantQuery(
    $page: Int!
    $pageSize: Int!
    $searchText: String
    ) {
    searchMerchant(
        page: $page
        pageSize: $pageSize
        searchText: $searchText
    ) {
      data {
        adminId
        merchantUserId
        merchantId
        companyName
        username
        logoUrl
      }
      total
      page
      pageSize
      totalPages
    }
  }
`;

interface UseSearchMerchantResult {
  data: SearchMerchantQueryQuery["searchMerchant"]
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
  loading: boolean;
  loadMore: () => void;
  hasMoreMerchants: boolean;
}

export const useSearchMerchant = (
  variables: QuerySearchMerchantArgs
): UseSearchMerchantResult => {
  const { data, loading, fetchMore } = useQuery<
    SearchMerchantQueryQuery,
    QuerySearchMerchantArgs
  >(searchMerchantQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const searchMerchantData = data?.searchMerchant?.data || [];
  const page = data?.searchMerchant?.page || variables.page;
  const pageSize = data?.searchMerchant?.pageSize || variables.pageSize;
  const total = data?.searchMerchant?.total || 0;
  const totalPages = data?.searchMerchant?.totalPages || 0;
  const hasMoreMerchants = page < totalPages;

    const loadMore = useCallback(() => {
      if (!hasMoreMerchants) return;
      fetchMore({
        variables: {
          ...variables,
          page: page + 1,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult || !fetchMoreResult?.searchMerchant) {
            return prev;
          }
          return {
            ...fetchMoreResult,
            searchMerchant: {
              ...fetchMoreResult?.searchMerchant,
              data: [
                ...(prev?.searchMerchant?.data || []),
                ...(fetchMoreResult?.searchMerchant?.data || []),
              ],
            },
          };
        },
      });
    }, [fetchMore, variables, page, hasMoreMerchants]);

  return {
    data: searchMerchantData as any,
    loading,
    loadMore,
    hasMoreMerchants,
    page,
    pageSize,
    total,
    totalPages,
  };
};